import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TalentPoolTag } from 'mojo-talent-pools';
import { TalentPoolsCandidates } from '@shared/models/talent-pools-candidates';
import { TalentPoolsService } from '@shared/services/talent-pools.service';
import { Store } from '@ngrx/store';
import { isModalConfirmed, ModalShow } from '@shared/modal';
import { addCandidatesToTalentPools } from 'mojo-talent-pools';

export interface AddCandidateModalData {
  candidateIds: number[];
  isSideDrawerAction?: boolean;
}

@Component({
  selector: 'mojo-add-candidate-modal',
  templateUrl: './add-candidate-modal.component.html',
  styleUrls: ['./add-candidate-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddCandidateModalComponent {
  talentPoolFormControl: UntypedFormControl = this.fb.control(null);
  form = new UntypedFormGroup({
    talentPool: this.talentPoolFormControl,
  });

  talentPoolTags: TalentPoolTag[] = [];

  constructor(
    private dialogRef: MatDialogRef<AddCandidateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddCandidateModalData,
    private fb: UntypedFormBuilder,
    private store: Store<{}>,
    public talentPoolService: TalentPoolsService,
  ) {}

  closeDialog() {
    this.store.dispatch(
      new ModalShow({
        title: 'Are you sure you want to leave this page?',
        message: 'All unsaved changes will be lost.',
      }),
    );
    this.store.select(isModalConfirmed).subscribe((close) => {
      if (close) {
        this.dialogRef.close(false);
      }
    });
  }

  onSubmit() {
    const talentPoolIds = [];
    const candidateIds = [];
    this.data.candidateIds.forEach((candidateId) => candidateIds.push(candidateId));
    this.talentPoolTags.forEach((tag) => talentPoolIds.push(tag.id));
    const talentPoolCandidates = {
      candidateIds,
      talentPoolIds,
    } as TalentPoolsCandidates;
    this.store.dispatch(
      addCandidatesToTalentPools({
        payload: talentPoolCandidates,
        isSideDrawerAction: !!this.data.isSideDrawerAction,
      }),
    );
    this.dialogRef.close(true);
  }
}
